import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:'',
    openid:'',
    accessid:'',
    accountId:'',
    uniqueId:'',
    actInfo:{},
    actExtend:{},
    groups:{},
  },  
  mutations: {    

    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_OPENID(state, openid) {
      state.openid = openid;
    },
    SET_ACCESSID(state, accessid) {
      state.accessid = accessid;
    },
    SET_ACCOUNTID(state, accountId) {
      state.accountId = accountId;
    },
    SET_UNIQUEID(state, uniqueId) {
      state.uniqueId = uniqueId;
    },
    SET_ACTINFO(state, actInfo) {
      state.actInfo = actInfo;
    },
    SET_GROUPS(state, groups) {
      state.groups = groups;
    },
  },
  actions: {
  },
  modules: {
  },
  getters: {
  }
})
